import {
  VerifyResDocument,
  VerifyResMutationResult,
  VerifyResMutationVariables,
} from "@graphql/api";

export default async function verifyRes(
  resId: string,
  validationMode: string,
  validationValue?: string
): Promise<string | false> {
  const client = global.window.apolloClient;

  const mutVars: VerifyResMutationVariables = { resId, validationMode, validationValue };
  const result: VerifyResMutationResult = await client.mutate({
    mutation: VerifyResDocument,
    variables: mutVars,
  });

  if (result.data.verifyRes.error) {
    return false;
  }

  return result.data.verifyRes.resId;
}
